import {InvoiceDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
import { getAllInvoicesSchema } from './_schema/getAllInvoices.schema';
import { UserState } from '../../reducers/UserReducer';
const FUNCTION_CODE = 'GET_ALL_INVOICE';

export async function getAllInvoices(
    userData: UserState['userProfileData'],
    optionalProps: string,
    page: number,
) {
    try {
        const invoices = await InvoiceDao.getAllInvoices(userData?.userToken as string, optionalProps, page);

        const parsedResult = getAllInvoicesSchema.parse(invoices);

        const metadata = {
            count: parsedResult.count,
            next: parsedResult.next,
            previous: parsedResult.previous
        };

        return {
            metadata,
            data: parsedResult.results
        };

    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation de la liste des factures',
            error: error
        });
    }
}
